<template class="bg-black">
  <div class="min-h-screen bg-black text-white p-10">
    <nav class="p-6 flex justify-between items-center">
      <img 
        src="@/assets/pics/logo3.png" 
        alt="Logo" 
        class="h-8 hover:opacity-80 transition-opacity"
        onclick="window.location.href = '/'"
      />
      <div class="flex gap-6">
        <router-link 
          v-for="link in navLinks" 
          :key="link.to"
          :to="link.to"
          class="text-gray-300 hover:text-white transition-colors"
        >
          {{ link.text }}
        </router-link>
      </div>
    </nav>

    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <Footer/>

    
  </div>
</template>

<script setup lang="ts">
import Footer from '@/components/Footer.vue'

const navLinks = [
  
  { text: '一对一私人咨询', to: '/vip' }
  // { text: '信号灯（测试）', to: '/signal' }
]
</script>

<style>
@font-face {
  font-family: 'FanWunHak-TW';
  src: url('@/assets/fonts/FanWunHak-TW/FanWunHak-TW-N.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

:root {
  font-family: 'FanWunHak-TW', sans-serif;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
